import type { Customer, CustomerStatus } from '@/types/customers'

// Name fields are optional on a customer, so render sites need a fallback
// rather than an empty string.
export const customerDisplayName = (c: { first_name: string; last_name: string }) =>
  `${c.first_name} ${c.last_name}`.trim() || 'Unnamed customer'

// Label for picker options: the most human-readable identifier available.
export const customerOptionLabel = (c: Customer) =>
  [c.first_name, c.last_name].filter(Boolean).join(' ') || c.company_name || c.contact_email || c.id

// Shared status → Badge variant mapping so every view renders statuses alike.
export const CUSTOMER_STATUS_VARIANT: Record<
  CustomerStatus,
  'default' | 'secondary' | 'destructive'
> = {
  lead: 'secondary',
  active: 'default',
  inactive: 'destructive',
}

// Status display labels — no raw enum values or CSS capitalize in the UI.
export const CUSTOMER_STATUS_LABELS: Record<CustomerStatus, string> = {
  lead: 'Lead',
  active: 'Active',
  inactive: 'Inactive',
}
